import { useState } from 'react';
import { CardElement, useStripe, useElements } from '@stripe/react-stripe-js';

// styles
import {
  PaymentFormContainer,
  OrderSummary,
  SummaryItem,
  SummaryTotal,
  CardElementContainer,
  CardError
} from './PaymentForm.styles';

// components
import PrimaryBtn from '../../../../components/btns/primary-btn/PrimaryBtn';

export default function PaymentForm ({ selectedTier, promoBonus, onPayment, isProcessing }) {
  const stripe = useStripe();
  const elements = useElements();
  const [cardComplete, setCardComplete] = useState(false);
  const [cardError, setCardError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Add null checking for selectedTier
  if (!selectedTier) {
    return (
      <PaymentFormContainer className='panel-bg'>
        <div className="no-tier-selected">
          <p>Please select a token tier to continue with payment.</p>
        </div>
      </PaymentFormContainer>
    );
  }

  const handleCardChange = (event) => {
    setCardComplete(event.complete);
    setCardError(event.error ? event.error.message : '');
  };
  const handleSubmit = async (event) => {
    event.preventDefault();

    if (isSubmitting) return;
    if (!stripe || !elements) return;
    if (!cardComplete) {
      setCardError('Please complete your card details');
      return;
    }

    setIsSubmitting(true);
    try {

      const { error, paymentMethod } = await stripe.createPaymentMethod({
        type: 'card',
        card: elements.getElement(CardElement),
      });

      if (error) {
        setCardError(error.message);
        return;
      }

      if (!paymentMethod || !paymentMethod.id) {
        setCardError('Failed to create payment method');
        return;
      }

      await onPayment(paymentMethod);
    } catch (error) {
      setCardError('An unexpected error occurred');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <PaymentFormContainer>
      <h2>COMPLETE YOUR PURCHASE</h2>
      <OrderSummary>
        <SummaryItem>
          <span>{selectedTier.name} ({selectedTier.tokens} token{selectedTier.tokens > 1 ? 's' : ''})</span>
          <span>${Number(selectedTier.price).toFixed(2)}</span>
        </SummaryItem>
        <SummaryItem>
          <span>Tax</span>
          <span>$0.00</span>
        </SummaryItem>
        {promoBonus > 0 && (
          <SummaryItem className="bonus">
            <span>Promo Bonus (+{promoBonus} token)</span>
            <span>FREE</span>
          </SummaryItem>
        )}
        <SummaryTotal>
          <span>Total ({selectedTier.tokens + promoBonus} token{selectedTier.tokens + promoBonus > 1 ? 's' : ''})</span>
          <span>${Number(selectedTier.price).toFixed(2)}</span>
        </SummaryTotal>
      </OrderSummary>

      <form onSubmit={handleSubmit}>
        <CardElementContainer>
        <h2 style={{ fontSize: "24px", fontFamily: 'Roboto Condensed', fontWeight: "200", color: "rgba(0, 0, 0, 0.67)", width: "100%", textAlign: "center" }}>CARD DETAILS</h2>
        <CardElement
            options={{
              style: {
                base: {
                  fontSize: '16px',
                  color: '#424770',
                  letterSpacing: '0.025em',
                  '::placeholder': {
                    color: '#aab7c4',
                  },
                },
                invalid: {
                  color: '#9e2146',
                },
              },
            }}
            onChange={handleCardChange}
          />
          {cardError && <CardError>{cardError}</CardError>}
        </CardElementContainer>

        <PrimaryBtn type="submit" fullWidth={true} disabled={!stripe || !cardComplete || isProcessing || isSubmitting} isLoading={isProcessing || isSubmitting} title={isProcessing || isSubmitting ? 'Processing...' : `COMPLETE PURCHASE`} onClick={handleSubmit} />
      </form>
    </PaymentFormContainer>
  );
};